
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import LegacyHome from "@/modules/home/LegacyHome";
import NewHome from "@/modules/home/NewHome";
import { useHomepageExperiment, recordHomepageExposure, refreshHomepageExperiment, } from "@/services/homepageExperiment";
import { useSignIn } from "@/redux/signIn";
import { useEffect, useRef } from "react";
export default function Home() {
    const state = useHomepageExperiment();
    const { loading } = useSignIn();
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (loading || !state.assignment || !ref.current)
            return;
        const expose = () => {
            if (document.visibilityState === "visible")
                void recordHomepageExposure();
        };
        const observer = typeof IntersectionObserver === "undefined"
            ? null
            : new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting)
                    expose();
            });
        observer?.observe(ref.current);
        if (!observer)
            expose();
        const onVisible = () => {
            if (ref.current?.getBoundingClientRect().top < window.innerHeight)
                expose();
        };
        document.addEventListener("visibilitychange", onVisible);
        return () => {
            observer?.disconnect();
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [loading, state.ready, state.assignment]);
    useEffect(() => {
        if (loading || !state.assignment)
            return;
        const refresh = () => {
            if (document.visibilityState === "visible")
                void refreshHomepageExperiment();
        };
        const timer = setInterval(refresh, 60000);
        window.addEventListener("focus", refresh);
        return () => {
            clearInterval(timer);
            window.removeEventListener("focus", refresh);
        };
    }, [loading, state.assignment?.key]);
    // Both arms share the loading boundary; no control flash before assignment.
    const waiting = loading || !state.ready;
    // Retain the localized legacy HTML and metadata for initial rendering/search.
    // Hide it until assignment resolves so treatment visitors never see a control flash.
    return (<div ref={ref} style={waiting ? { visibility: "hidden" } : undefined} aria-busy={waiting}>
      {!waiting && state.value ? <NewHome /> : <LegacyHome />}
    </div>);
}

    async function __Next_Translate__getStaticProps__1a179dc8a99__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a179dc8a99__ as getStaticProps }
  